export default __webpack_public_path__ + "static/media/section-heading-priority-ticket.1b6f5c7e.svg";